/**
 * A collection's membership is applied by the search endpoint, from `?collection=<slug>`. The
 * client only ever holds the user's own narrowing within it.
 */
import { DEFAULT_PAGE_SIZE } from "client/products/constants/filterDefinitions";
import { EMPTY_PRODUCT_SELECTION } from "client/products/utils";

export const SEARCH_DEFAULTS = {
  q: "",
  page: 1,
  page_size: DEFAULT_PAGE_SIZE,
  sort: "",
  ...EMPTY_PRODUCT_SELECTION,
};
